
import { Component, Mixins } from "vue-property-decorator";
import { AthleteRoutingMixin, VuetifyMixin } from "@/mixins";

@Component({})
export default class EditRecruitingProfileVideos extends Mixins(VuetifyMixin, AthleteRoutingMixin) {
}
